import { Component, inject } from '@angular/core';
import { EwentsWentyComponent, provideWenty } from '@ewentscompany/ewents-components';
import { getServiceUrl, SERVICES } from '../shared/constants/api.constants';
import { DeviceInfoService } from '../shared/services/device-info.service';

/** Portal host for the shared Wenty panel (`surface=portal`, fixed model). */
@Component({
  selector: 'app-wenty',
  standalone: true,
  imports: [EwentsWentyComponent],
  template: '<ewents-wenty />',
  providers: [
    provideWenty(() => {
      const deviceInfo = inject(DeviceInfoService);
      return {
        surface: 'portal',
        getBaseUrl: () => getServiceUrl(SERVICES.WENTY),
        getDeviceHeaders: () => deviceInfo.getSessionHeaders(),
      };
    }),
  ],
})
export class WentyComponent {}
